import {createRouter, createWebHashHistory} from 'vue-router'
import Home from '../components/Home.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/datenschutz',
        name: 'datenschutz',
        component: () => import('../components/Datenschutz.vue')
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: () => import('../components/Impressum.vue')
    },
    {
        path: '/bilder',
        name: 'bildernew',
        redirect: '/hochzeit/bilder'
    },
    {
        path: '/hochzeit',
        name: 'hochzeit',
        component: () => import('../components/RouterView.vue'),
        children: [
            {
                path: 'erfolgreich',
                name: 'erfolgreich',
                component: () => import('../components/AnmeldungSuccess.vue')
            },
            {
                path: 'erfolgreich-absage',
                name: 'erfolgreich-absage',
                component: () => import('../components/AbmeldungSuccess.vue')
            },
            {
                path: 'anfahrt',
                name: 'anfahrt',
                component: () => import('../components/Informationen.vue')
            },
            {
                path: 'programm',
                name: 'programm',
                component: () => import('../components/Programm.vue')
            },
            {
                path: 'erfolgreich-beitrag',
                name: 'erfolgreich-beitrag',
                component: () => import('../components/AnmeldungSuccessBeitrag.vue')
            },
            {
                path: 'geschenke',
                name: 'geschenke',
                component: () => import('../components/Wunschliste.vue')
            },
            {
                path: 'ablauf',
                name: 'ablauf',
                component: () => import('../components/Ablauf.vue')
            },
            {
                path: 'bilder',
                name: 'bilder',
                component: () => import('../components/BilderSammlung.vue')
            },
            {
                path: 'uebernachtung',
                name: 'uebernachtung',
                component: () => import('../components/Uebernachtung.vue')
            },
            {
                path: 'kontakt',
                name: 'kontakt',
                component: () => import('../components/Kontakt.vue')
            },
            {
                path: 'melden',
                name: 'melden',
                component: () => import('../components/Melden.vue')
            },
            {
                path: 'anmeldung',
                name: 'anmeldung',
                component: () => import('../components/Anmeldung.vue')
            },
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
